module.exports = __webpack_public_path__ + "9deaa40f8ae40dae10cdd58c4eb1389c.gif";